// src/lib/feature-flags.ts
//
// Feature flags genéricos del frontend. Se controlan vía variables de entorno
// NEXT_PUBLIC_* (visibles en el navegador). Agregar aquí los flags de dominio
// (ligas, equipos, etc.) cuando existan.
//
// NOTA: no hay flags de cobros/suscripciones — esa fase no está implementada.

/** Habilita el registro de nuevos usuarios. Por defecto activado. */
export const isRegistrationEnabled =
  process.env.NEXT_PUBLIC_ENABLE_REGISTRATION !== "false";

/**
 * Habilita la landing de marketing en la home (`/{locale}`). Por defecto activado.
 * Si se desactiva, la home redirige a `/login` (ver `(marketing)/page.tsx`).
 */
export const isLandingEnabled =
  process.env.NEXT_PUBLIC_ENABLE_LANDING !== "false";

/** Habilita el tracking de analytics públicos (landing). Por defecto activado. */
export const isPublicAnalyticsEnabled =
  process.env.NEXT_PUBLIC_ENABLE_PUBLIC_ANALYTICS !== "false";

/**
 * Kill-switch de Google Sign-In (OAuth via Hosted UI + PKCE).
 * Default DESACTIVADO (opt-in): solo se habilita si la env var vale exactamente "true".
 */
export const isGoogleAuthEnabled =
  process.env.NEXT_PUBLIC_ENABLE_GOOGLE_AUTH === "true";

/**
 * Superficie del delegado en `/scoresheet` (FEATURE-067/068).
 * Default DESACTIVADO (opt-in): con el flag apagado la ruta sirve el
 * placeholder estático; se enciende al cerrar la cancha (FEATURE-068).
 */
export const isScoresheetEnabled =
  process.env.NEXT_PUBLIC_ENABLE_SCORESHEET === "true";

/**
 * Galería del sistema de diseño en `(public)/design`.
 * Default DESACTIVADO (opt-in): con el flag apagado la ruta sirve el placeholder.
 * No es secreta —es un sistema de diseño—, pero tampoco es para el público.
 */
export const isDesignGalleryEnabled =
  process.env.NEXT_PUBLIC_ENABLE_DESIGN_GALLERY === "true";

/**
 * ¿Corremos detrás de la CloudFront Function que sirve `/<slug>` (FEATURE-002)?
 * Con ella activa, `/<slug>` es la **portada de la asociación** y esa es la URL pública
 * de la liga; sin ella (dev, previews, S3 pelado) esa ruta no existe y hay que emitir la
 * forma larga. Default DESACTIVADO (opt-in): olvidarlo degrada a una URL fea, nunca a un
 * enlace roto (FEATURE-112 CB-002).
 */
export const areShortUrlsEnabled =
  process.env.NEXT_PUBLIC_ENABLE_SHORT_URLS === "true";

/**
 * El **reglamento público** (FEATURE-195 a 198): la sección del menú del hincha y el
 * tab de la portada de asociación.
 *
 * Default DESACTIVADO (opt-in). Con el flag apagado el reglamento **no existe para el
 * visitante**: no aparece en el menú ni en la barra, y sus URLs no resuelven —`"rules"` y
 * `"reglamento"` quedan fuera del vocabulario cerrado, así que caen a Inicio—. Filtrar
 * solo el menú dejaría la funcionalidad accesible para cualquiera con el link, que es
 * justo lo que este flag impide.
 *
 * Se enciende cuando la decisión de publicarlo sea explícita: el reglamento muestra lo que
 * la liga tiene configurado, y hay rulesets que todavía no reflejan cómo se juega de verdad.
 */
export const isRulesEnabled = process.env.NEXT_PUBLIC_ENABLE_RULES === "true";

/**
 * Páginas legales y de ayuda de la vitrina (`/terms`, `/privacy`, `/faq`, FEATURE-178).
 * Default DESACTIVADO (opt-in): el texto es un borrador de producto y **no se despliega
 * sin revisión de abogado** (FEATURE-178 §14.6).
 *
 * Con el flag apagado las rutas sirven un placeholder y —esto es lo que importa— el pie y
 * el checkbox del registro se quedan **exactamente como están hoy**: marcados y sin
 * enlace. Enlazar hacia un placeholder sería un link muerto con otra forma, que es el
 * problema que esta feature vino a resolver.
 */
export const isLegalPagesEnabled =
  process.env.NEXT_PUBLIC_ENABLE_LEGAL_PAGES === "true";
